<template>
  <div>
    <div class="inner-header">
      <nav class="navbar fixed-top animate__animated animate__slideInRight">
        <a @click="$router.go(-1)" class="back-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
            <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
              <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2" />
              <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
            </g>
          </svg>
        </a>
        <a href="javascript:void(0);" class="link-title">Broker CTC History</a>
      </nav>
    </div>
    <div class="inner-page animate__animated animate__slideInRight">
      <div class="container-fluid">
        <div class="row">
          <!-- Enquiry Card -->
          <div class="col-12 tab-holder">
            <b-tabs content-class="mt-3" justified @input="switchTabs">
              <b-tab title="Incoming CTC" active>
                <div class="card enquiry-card m-height">
                  <b-list-group class="list-group-flush">
                    <b-list-group-item v-for="(item,index) in incomingCalls" :key="item.id">
                      <div class="row">
                        <div class="col-8 pr-1">
                          <span class="name" v-if="item.start_date">{{item.start_date}}</span>
                          <span class="project-name d-block " v-if="item.start_time ">{{item.start_time}} {{item.end_time ? '-' + item.end_time : ''}}</span>
                          <span class="project-name " v-if="item.duration ">Duration: {{item.duration}}</span>
                        </div>
                        <div class="col-4 pl-1 text-right">
                          <span class="label-tag" v-if="item.status">{{item.status}}</span>
                          <audio :ref="`audio-incoming-${index}`" @ended="audioEnded()" v-if="item.recording_url">
                            <source :src="item.recording_url" type="">
                          </audio>
                          <button type="button" class="btn" @click="playAudio(item,index)" v-if="item.recording_url && !item.is_playing"><img src="@/assets/play-recording.svg" alt="" height="16" width="16" /> Play</button>
                          <button type="button" class="btn" @click="pauseAudio()" v-if="item.recording_url && item.is_playing"><img src="@/assets/pause-recording.svg" alt="" height="16" width="16" /> Pause</button>
                        </div>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-tab>
              <b-tab title="Outgoing CTC">
                <div class="card enquiry-card m-height">
                  <b-list-group class="list-group-flush">
                    <b-list-group-item v-for="(item,index) in outgoingCalls" :key="item.id">
                      <div class="row">
                        <div class="col-8 pr-1">
                          <span class="name" v-if="item.start_date">{{item.start_date}}</span>
                          <span class="project-name d-block " v-if="item.start_time ">{{item.start_time}} {{item.end_time ? '-' + item.end_time : ''}}</span>
                          <span class="project-name " v-if="item.duration ">Duration: {{item.duration}}</span>
                        </div>
                        <div class="col-4 pl-1 text-right">
                          <span class="label-tag" v-if="item.status">{{item.status}}</span>
                          <audio :ref="`audio-outgoing-${index}`" @ended="audioEnded()" v-if="item.recording_url">
                            <source :src="item.recording_url" type="">
                          </audio>
                          <button type="button" class="btn" @click="playAudio(item,index)" v-if="item.recording_url && !item.is_playing"><img src="@/assets/play-recording.svg" alt="" height="16" width="16" /> Play</button>
                          <button type="button" class="btn" @click="pauseAudio()" v-if="item.recording_url && item.is_playing"><img src="@/assets/pause-recording.svg" alt="" height="16" width="16" /> Pause</button>
                        </div>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'CPCallLog',
  data() {
    return {
      incomingCalls: [],
      outgoingCalls: [],
      queryP: {},
      status: 'incoming',
      playingCall: null,
      currentPlayingElement: null
    }
  },
  methods: {
    getCallLogDetails() {
      this.$axios.get(`brokers/${this.$route.params.brokerid}/call_logs`, {
        params: {
          status: this.status
        }
      }).then((res) => {
        if (this.status === 'incoming') {
          this.incomingCalls = res && res.data && res.data.call_logs;
        } else {
          this.outgoingCalls = res && res.data && res.data.call_logs;
        }
      }).catch(err => console.log(err));
    },
    switchTabs(tabIndex) {
      if (this.currentPlayingElement) {
        this.pauseAudio();
      }
      switch (tabIndex) {
        case 0:
          {
            this.status = 'incoming';
            break;
          }
        case 1:
          {
            this.status = 'outgoing';
            break;
          }
      }
      this.getCallLogDetails();
    },
    playAudio(call, index) {
      this.pauseAudio();
      if (!call.is_playing) {
        this.currentPlayingElement = this.$refs[`audio-${this.status}-${index}`][0];
        this.playingCall = index;
        if (this.status === 'incoming') {
          this.$set(this.incomingCalls[index], 'is_playing', true);
        } else {
          this.$set(this.outgoingCalls[index], 'is_playing', true);
        }
        this.currentPlayingElement.play();
      }
    },
    pauseAudio() {
      if (this.currentPlayingElement && !this.currentPlayingElement.paused) {
        this.currentPlayingElement.pause();
        if (this.status === 'incoming') {
          this.$set(this.incomingCalls[this.playingCall], 'is_playing', false);
        } else {
          this.$set(this.outgoingCalls[this.playingCall], 'is_playing', false);
        }
      }

    },
    audioEnded() {
      if (this.status === 'incoming') {
        this.$set(this.incomingCalls[this.playingCall], 'is_playing', false);
      } else {
        this.$set(this.outgoingCalls[this.playingCall], 'is_playing', false);
      }
    }
  },
  beforeDestroy() {
    this.pauseAudio();
  }
}
</script>
<style scoped>
.inner-page {
  margin-top: 60px;
  background: #ffffff;
}
</style>